import { ThemeKeysEnum } from '../api/models';

export const DefaultDarkThemeCollection: Map<ThemeKeysEnum, string> = new Map<
	ThemeKeysEnum,
	string
>([
	[ThemeKeysEnum.PrimaryMainColorCount, '1'],
	[ThemeKeysEnum.Primary50, '#eee6de'],
	[ThemeKeysEnum.Primary100, '#ddcebd'],
	[ThemeKeysEnum.Primary200, '#ccb69d'],
	[ThemeKeysEnum.Primary300, '#bb9f7d'],
	[ThemeKeysEnum.Primary400, '#aa885e'],
	[ThemeKeysEnum.Primary500, '#99713d'],
	[ThemeKeysEnum.Primary600, '#77572e'],
	[ThemeKeysEnum.Primary700, '#573e1f'],
	[ThemeKeysEnum.Primary800, '#382712'],
	[ThemeKeysEnum.Primary900, '#1c1206'],
	[ThemeKeysEnum.Primary950, '#050301'],

	// Secondary Colors
	[ThemeKeysEnum.SecondaryMainColorCount, '1'],
	[ThemeKeysEnum.Secondary50, '#e9e9e9'],
	[ThemeKeysEnum.Secondary100, '#d3d3d3'],
	[ThemeKeysEnum.Secondary200, '#bdbdbd'],
	[ThemeKeysEnum.Secondary300, '#a9a9a9'],
	[ThemeKeysEnum.Secondary400, '#949494'],
	[ThemeKeysEnum.Secondary500, '#808080'],
	[ThemeKeysEnum.Secondary600, '#636363'],
	[ThemeKeysEnum.Secondary700, '#484848'],
	[ThemeKeysEnum.Secondary800, '#2e2e2e'],
	[ThemeKeysEnum.Secondary900, '#161616'],
	[ThemeKeysEnum.Secondary950, '#030303'],

	// Default Font
	[ThemeKeysEnum.DefaultFontFamily, 'Plus Jakarta Sans'],
	[ThemeKeysEnum.DefaultFontSize, '18px'],
	[ThemeKeysEnum.DefaultFontWeight, '300'],
	[ThemeKeysEnum.DefaultFontColor, '#ddcebd'],

	// Item
	[ThemeKeysEnum.ItemBg, '#1c1206'],
	[ThemeKeysEnum.ItemBorderColor, '#bb9f7d'],
	[ThemeKeysEnum.ItemBorderStyle, 'solid'],
	[ThemeKeysEnum.ItemBorderWidth, '2px'],
	[ThemeKeysEnum.ItemBorderRadius, '48px'],
	[ThemeKeysEnum.ItemTitleFontFamily, 'Plus Jakarta Sans'],
	[ThemeKeysEnum.ItemTitleFontSize, '22px'],
	[ThemeKeysEnum.ItemTitleFontWeight, '800'],
	[ThemeKeysEnum.ItemTitleFontColor, '#ddcebd'],
	[ThemeKeysEnum.ItemDescriptionFontFamily, 'Plus Jakarta Sans'],
	[ThemeKeysEnum.ItemDescriptionFontSize, '18px'],
	[ThemeKeysEnum.ItemDescriptionFontWeight, '300'],
	[ThemeKeysEnum.ItemDescriptionFontColor, '#ddcebd'],
	[ThemeKeysEnum.ItemPriceFontFamily, 'Plus Jakarta Sans'],
	[ThemeKeysEnum.ItemPriceFontSize, '18px'],
	[ThemeKeysEnum.ItemPriceFontWeight, '500'],
	[ThemeKeysEnum.ItemPriceFontColor, '#ddcebd'],
	[ThemeKeysEnum.ItemAmountFontFamily, 'Plus Jakarta Sans'],
	[ThemeKeysEnum.ItemAmountFontSize, '18px'],
	[ThemeKeysEnum.ItemAmountFontWeight, '300'],
	[ThemeKeysEnum.ItemAmountFontColor, '#ddcebd'],

	// Section
	[ThemeKeysEnum.SectionSeperatorColor, '#bb9f7d'],
	[ThemeKeysEnum.SectionTitleFontFamily, 'Plus Jakarta Sans'],
	[ThemeKeysEnum.SectionTitleFontSize, '32px'],
	[ThemeKeysEnum.SectionTitleFontWeight, '600'],
	[ThemeKeysEnum.SectionTitleFontColor, '#ddcebd'],

	// Menu
	[ThemeKeysEnum.MenuBg, '#0c0803'],
	[ThemeKeysEnum.MenuBgAlt, '#030303'],
	[ThemeKeysEnum.ChangingBgEnabled, 'false'],
	[ThemeKeysEnum.MenuTitleFontFamily, 'Miss Fajardose'],
	[ThemeKeysEnum.MenuTitleFontSize, '82px'],
	[ThemeKeysEnum.MenuTitleFontWeight, '500'],
	[ThemeKeysEnum.MenuTitleFontColor, '#ddcebd'],

	// Control
	[ThemeKeysEnum.ControlFontFamily, 'Plus Jakarta Sans'],
	[ThemeKeysEnum.ControlFontSize, '18px'],
	[ThemeKeysEnum.ControlFontWeight, '300'],
	[ThemeKeysEnum.ControlFontColor, '#ddcebd'],
	[ThemeKeysEnum.ControlDisabled, '#808080'],
	[ThemeKeysEnum.ControlBg, '#161616'],
	[ThemeKeysEnum.ControlBgHover, '#2e2e2e'],
	[ThemeKeysEnum.ControlBgLight, '#e6d3bc'],
	[ThemeKeysEnum.ControlBgDark, '#161616'],
	[ThemeKeysEnum.ControlHero, '#bb9f7d'],
	[ThemeKeysEnum.ControlHeroHover, '#ccb69d'],
	[ThemeKeysEnum.ControlBorderColor, '#bb9f7d'],
	[ThemeKeysEnum.ControlBorderStyle, 'solid'],
	[ThemeKeysEnum.ControlBorderWidth, '2px'],
	[ThemeKeysEnum.ControlBorderRadius, '24px'],

	// QR Code
	[ThemeKeysEnum.QrCodeBgLight, '#ddcebd'],
	[ThemeKeysEnum.QrCodeBgDark, '#1c1206'],
]);
